module.exports = __webpack_public_path__ + "img/cover9.1fcb7d25.png";